const preludeEnv = import.meta.env.VITE_PRELUDE_ENVIRONMENT;
export const msAppId =
  localStorage.getItem("msAppId") ?? import.meta.env.VITE_MS_APP_ID;

export const isLocal = window.location.hostname === "localhost";
export const isUs1 = preludeEnv === "us1";
export const isEu1 = preludeEnv === "eu1";
export const isUs2 = preludeEnv === "us2";
